import { Button, DialogContent, DialogContentText, TextField } from '@mui/material';
import React, { useContext, useState } from 'react';
import ImageUploading from 'react-images-uploading';
import { ColorCustomizer } from './ColorCustomizer';
import { CustomizationContext } from './contexts/customizationContext';
import useInputState from './hooks/useInputState';
import './styles/Customizer.css';

export function Customizer({ setDialogType, customizationType }) {
  // stateful variables
  const { customizations, setCustomizations } = useContext(CustomizationContext);
  const [value, handleChange] = useInputState('');
  const [images, setImages] = useState();

  //  setDialogType below "closes" the Dialog
  const changeBackgroundImage = (imageUrl) => {
    setCustomizations({
      ...customizations,
      background: {
        ...customizations.background,
        image: typeof imageUrl === 'string' ? imageUrl : value,
        type: customizationType,
      },
    });
    setDialogType('');
  };

  return (
    <>
      {/* renders either color selector or image selector */}
      {customizationType === 'color' ? (
        <ColorCustomizer setDialogType={setDialogType} />
      ) : (
        <DialogContent>
          <DialogContentText>You can add any background image by entering the image URL below:</DialogContentText>
          <TextField
            className="text-field"
            label="Image URL"
            value={value}
            onChange={handleChange}
            fullWidth
            autoFocus
          />
          <Button variant="contained" onClick={changeBackgroundImage} sx={{ bgcolor: customizations.colors.main }}>
            Change Background Image
          </Button>
          <DialogContentText style={{ margin: '20px 0px 10px 0px' }}>
            Or you can upload an image here:
          </DialogContentText>
          <ImageUploading
            maxNumber={1}
            value={images}
            onChange={(images) => {
              setImages(images);
              changeBackgroundImage(images[0].dataURL);
            }}
          >
            {({ imageList, dragProps, isDragging, onImageUpload }) => (
              <div>
                <Button variant="contained" onClick={onImageUpload} sx={{ bgcolor: customizations.colors.main }}>
                  Click to Upload An Image
                </Button>
              </div>
            )}
          </ImageUploading>
        </DialogContent>
      )}
    </>
  );
}
